export const CLEAR_ACCOUNT = 'CLEAR_ACCOUNT';

export const DELETE_ACCOUNT = 'DELETE_ACCOUNT';
export const DELETE_ACCOUNT_ERROR = 'DELETE_ACCOUNT_ERROR';
export const DELETE_ACCOUNT_SUCCESS = 'DELETE_ACCOUNT_SUCCESS';

export const GET_ACCOUNTS = 'GET_ACCOUNTS';
export const GET_ACCOUNTS_ERROR = 'GET_ACCOUNTS_ERROR';
export const GET_ACCOUNTS_SUCCESS = 'GET_ACCOUNTS_SUCCESS';

export const GET_ACCOUNT = 'GET_ACCOUNT';
export const GET_ACCOUNT_ERROR = 'GET_ACCOUNT_ERROR';
export const GET_ACCOUNT_SUCCESS = 'GET_ACCOUNT_SUCCESS';

export const SAVE_ACCOUNT = 'SAVE_ACCOUNT';
export const SAVE_ACCOUNT_ERROR = 'SAVE_ACCOUNT_ERROR';
export const SAVE_ACCOUNT_SUCCESS = 'SAVE_ACCOUNT_SUCCESS';



// WEBPACK FOOTER //
// ./src/components/Syndicates/Syndicate/Accounts/constants.js